<template>
  <div id="app">
    <Navbar/>
    <div class="content container-fluid">
    <router-view/>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Footer from './components/Footer'
import Navbar from './components/Navbar'

export default {
  name: 'App',
  components: {
    Footer,
    Navbar
  },
}
</script>

<style src="./assets/sass/app.scss" lang="scss"></style>
<style lang="scss" scoped>
#app {
  min-height: 100%;
  margin-bottom: 80px;
}

.content {
  margin-top: 15px;
}
</style>

